import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const Date_Format = 'YYYY-MM-DD';
export const TIme_Format = 'HH:mm:ss';
export const Year_Format = 'YYYY';

export const convertSecondsToMinuteSecond = (timeInSeconds: number): string => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds - minutes * 60;
  let minutesInText = '00';
  let secondsInText = '00';

  if (minutes) {
    minutesInText = minutes < 10 ? `0${minutes + ''}` : minutes + '';
  }

  if (seconds < 10) {
    secondsInText = `0${seconds + ''}`;
  } else {
    secondsInText = seconds + '';
  }

  return `${minutesInText}:${secondsInText}`;
};

export const delay = (timeDelay: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, timeDelay * 1000);
  });
};

export const getDayDifference = (startDate: Dayjs, endDate: Dayjs): number => {
  const differenceMs = endDate.diff(startDate);
  const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
  return differenceDays;
};

export const createDateFromTime = (timeString: string): Dayjs => {
  // Get today's date
  const todayDate = dayjs().format(Date_Format);

  // Combine date and time
  const combinedDateTime = `${todayDate} ${timeString}`;
  console.log({ combinedDateTime, timeString });

  // Create a Day.js object from the combined date and time
  return dayjs(combinedDateTime, 'YYYY-MM-DD hh:mm:ss A');
};

export const findWeekendDays = (startDay: string, endDay: string): string[] => {
  const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const startIndex = daysOfWeek.indexOf(startDay.toLowerCase());
  const endIndex = daysOfWeek.indexOf(endDay.toLowerCase());

  if (startIndex > endIndex) {
    daysOfWeek.splice(startIndex);
    daysOfWeek.splice(0, endIndex + 1);
    return daysOfWeek.map((item) => item.charAt(0).toUpperCase() + item.slice(1));
  }

  const weekDays = daysOfWeek.slice(startIndex, endIndex + 1);
  const weekendDays = daysOfWeek.filter((day) => weekDays.indexOf(day) === -1);
  return weekendDays.map((item) => item.charAt(0).toUpperCase() + item.slice(1));
};

export const getCurrentYear = (): number => {
  const currentDate = new Date();
  // Get the current year from the Date object
  return currentDate.getFullYear();
};
